import { Subject, Observable } from 'rxjs';
import * as i0 from "@angular/core";
export class CBHelperService {
    constructor() {
        this._subjectSelectedCommunity = new Subject();
        this._subjectRollbackCommunity = new Subject();
        this._subjectSelctedManagementCompany = new Subject();
        this._subjectRollbackManagementCompany = new Subject();
        this._subjectWidgetContext = new Subject();
        this._subjectFilterFormReady = new Subject();
        this._subjectForceRefresh = new Subject();
        this._subjectUpdateSecurityInfo = new Subject();
    }
    getContext() {
        return new Observable((observer) => {
            this._subjectSelectedCommunity.subscribe((context) => observer.next(context));
            this._subjectSelctedManagementCompany.subscribe((context) => observer.next(context));
        });
    }
    getLocalContext() {
        return this._selectedCommunity || this._selectedManagementCompany;
    }
    updateContext(context) {
        this._selectedCommunity = null;
        this._selectedManagementCompany = null;
        if (!!context) {
            if (!!context.communityId) {
                this._selectedCommunity = context;
            }
            else {
                this._selectedManagementCompany = context;
            }
        }
    }
    updateWidgetContextSubject(context) {
        this._subjectWidgetContext.next(context);
    }
    getWidgetContextSubject() {
        return this._subjectWidgetContext;
    }
    updateSelectedCommunitySubject(community) {
        this._selectedCommunity = community;
        this._selectedManagementCompany = null;
        this._subjectSelectedCommunity.next(community);
    }
    getSelectedCommunitySubject() {
        return this._subjectSelectedCommunity;
    }
    updateManagementCompanySubject(property) {
        this._selectedManagementCompany = property;
        this._selectedCommunity = property.communityContext;
        this._subjectSelctedManagementCompany.next(property);
    }
    getSelectedManagementCompanySubject() {
        return this._subjectSelctedManagementCompany;
    }
    getSelectedCommunity() {
        return this._selectedCommunity;
    }
    getSelectedManagementCompany() {
        return this._selectedManagementCompany;
    }
    getSubjectFilterFormReady() {
        return this._subjectFilterFormReady;
    }
    updateSubjectFilterFormReady(filterForm) {
        this._filterForm = filterForm;
        this._subjectFilterFormReady.next(true);
    }
    getFilterForm() {
        return this._filterForm;
    }
    getSubjectForceRefresh() {
        return this._subjectForceRefresh;
    }
    updateSubjectForceRefresh(flag) {
        this._subjectForceRefresh.next(flag);
    }
    getSubjectSecurityInfo() {
        return this._subjectUpdateSecurityInfo;
    }
    updateSubjectSecurityInfo(value) {
        this._subjectUpdateSecurityInfo.next(value);
    }
    rollbackCommunityContext(community) {
        this._selectedCommunity = community;
        this._selectedManagementCompany = null;
        this._subjectRollbackCommunity.next(community);
        this.updateContext(community);
        this.updateWidgetContextSubject(community);
    }
    rollbackManagementCompanyContext(property) {
        this._selectedManagementCompany = property;
        this._selectedCommunity = property.communityContext;
        this._subjectRollbackManagementCompany.next(property);
    }
    getRollbackContext() {
        return new Observable((observer) => {
            this._subjectRollbackCommunity.subscribe((context) => observer.next(context));
            this._subjectRollbackManagementCompany.subscribe((context) => observer.next(context));
        });
    }
    getRollbackCommunityContext() {
        return this._subjectRollbackCommunity;
    }
    getRollbackManagementCompanyContext() {
        return this._subjectRollbackManagementCompany;
    }
}
CBHelperService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CBHelperService_Factory() { return new CBHelperService(); }, token: CBHelperService, providedIn: "root" });
